export const LINKEDIN_URL = "https://www.linkedin.com/in/anjalism";

export const NAV_LINKS = [
  { id: "health-check", label: "Health Check" },
  { id: "services", label: "Services" },
  { id: "about", label: "About" },
  { id: "sample-report", label: "Sample Report" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

export const MARQUEE_ITEMS = [
  "AML & Financial Crime",
  "Regulatory Compliance",
  "Risk & Governance",
  "Commercial Contracts",
  "Legal Operations",
  "Fractional In-House Support",
];

export const EXPERTISE = [
  {
    title: "Anti-Money Laundering & Financial Crime",
    body: "Risk assessments, customer due diligence, sanctions, screening and financial crime controls.",
  },
  {
    title: "Regulatory Compliance",
    body: "Compliance frameworks, regulatory reviews, policy development and monitoring.",
  },
  {
    title: "Risk & Governance",
    body: "Internal controls, governance documentation, reporting and risk management.",
  },
  {
    title: "Commercial Contracts",
    body: "Drafting, reviewing and negotiating commercial agreements and business documentation.",
  },
  {
    title: "Legal Operations",
    body: "Practical support for the day-to-day legal and compliance needs of a business.",
  },
  {
    title: "Fractional In-House Support",
    body: "Ongoing contracts, compliance and governance support without a full-time hire.",
  },
];

export const SERVICES = [
  {
    title: "AML & Financial Crime Compliance",
    body: "Independent reviews of AML arrangements, risk assessments, policies, procedures and internal controls. Support with identifying compliance gaps and implementing practical improvements.",
  },
  {
    title: "Regulatory Compliance & Governance",
    body: "Support with regulatory compliance frameworks, internal policies, governance documentation, regulatory change and risk management.",
  },
  {
    title: "Contracts & Commercial Support",
    body: "Drafting, reviewing and managing commercial agreements, including service agreements, supplier contracts, NDAs and other business documentation. Support with contract negotiations, contractual obligations and day-to-day commercial matters, within the scope of applicable professional and regulatory requirements.",
  },
  {
    title: "Fractional In-House Support",
    body: "Flexible support for businesses that need additional capacity across contracts, compliance, governance and legal operations. Available for defined projects or ongoing engagements, without the commitment of a full-time hire.",
  },
];

export const HEALTH_STEPS = [
  {
    title: "Initial discussion",
    body: "We agree on the scope of the review and the documents required.",
  },
  {
    title: "Document review",
    body: "I assess the agreed documentation against applicable requirements.",
  },
  {
    title: "Written report",
    body: "You receive a structured report with findings and recommended actions.",
  },
  {
    title: "Follow-up call",
    body: "We discuss the findings and any questions you may have.",
  },
];

export const WHY_POINTS = [
  "Direct access to an experienced consultant",
  "Practical, risk-based recommendations",
  "Clear written reports and next steps",
];

export const QUALIFICATIONS = [
  "ICA Diploma in Anti Money Laundering",
  "ICA Advanced Certificate in Regulatory Compliance",
  "LLM, Intellectual Property, Cardiff University",
  "BA LLB (Hons.)",
  "Advocate enrolled in India",
];

export const SAMPLE_FINDINGS = [
  { area: "Business-wide risk assessment", status: "Attention", tone: "text-cherry", note: "The current assessment predates the firm's expansion into two new service lines." },
  { area: "Customer due diligence", status: "Sound", tone: "text-gold", note: "Onboarding checks are applied consistently, with enhanced checks for higher-risk clients." },
  { area: "Staff training", status: "Developing", tone: "text-gold", note: "Refresher training is overdue for two members of the engagement team." },
];

export const FAQS = [
  {
    q: "What does an AML Health Check involve?",
    a: "I review your risk assessment, policies and procedures against the relevant regulatory requirements and supervisory guidance. You receive a written report setting out any gaps, areas for improvement and recommended next steps, prioritised by risk. It is an advisory review, not an audit or a regulatory inspection.",
  },
  {
    q: "Can you help with ongoing compliance requirements?",
    a: "Yes. Some clients come to me for a one-off review, others prefer continuing support. I can provide periodic reviews, document updates and general compliance, contracts and governance assistance on a fractional basis, depending on what your business needs.",
  },
  {
    q: "Do you work with businesses outside the UK?",
    a: "Yes. I have worked across the UK, UAE and Australia. Where local requirements differ, I will always be clear about the scope of my advice and, where necessary, recommend that you take local advice alongside my work.",
  },
  {
    q: "Do you provide legal advice?",
    a: "No. I am an independent legal and compliance professional, not a UK solicitor or a law firm, and I do not provide legal advice. My services are provided subject to applicable professional and regulatory requirements, and I do not undertake reserved legal activities in any jurisdiction.",
  },
  {
    q: "Does a review guarantee a successful regulatory inspection?",
    a: "No, and I would not suggest otherwise. A review is intended to help you identify and address weaknesses, but I cannot guarantee the outcome of any regulatory inspection or supervision.",
  },
];

export const SERVICE_OPTIONS = [
  "AML Health Check",
  "Regulatory Compliance & Governance",
  "Contracts & Commercial Support",
  "Fractional In-House Support",
  "General Enquiry",
];
